import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/ResetPasswordPage')));
export const Home = Loadable(lazy(() => import('../pages/Home/index')));
export const AppUserManageList = Loadable(lazy(() => import('../pages/AppUserManage/list')));
export const AppUserManageAdd = Loadable(lazy(() => import('../pages/AppUserManage/add')));
export const UserManageList = Loadable(lazy(() => import('../pages/UserManage/list')));
export const UserManageAdd = Loadable(lazy(() => import('../pages/UserManage/add')));
export const DeviceManageList = Loadable(lazy(() => import('../pages/DeviceManage/list')));
export const DeviceManageAdd = Loadable(lazy(() => import('../pages/DeviceManage/add')));
export const DeviceModelList = Loadable(lazy(() => import('../pages/DeviceManage/templateList')));
export const DeviceTypeList = Loadable(lazy(() => import('../pages/DeviceManage/deviceTypeList')));
export const FeedbackList = Loadable(lazy(() => import('../pages/FeedbackManage/list')));
export const FeedbackDetail = Loadable(lazy(() => import('../pages/FeedbackManage/detail')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const TankTypeList = Loadable(lazy(() => import('../pages/TankType/list')));
export const TankTypeSecondList = Loadable(lazy(() => import('../pages/TankType/secondList')));
export const TankTypeAddSecond = Loadable(lazy(() => import('../pages/TankType/addSecondType')));
export const TankTypeSecondDetail = Loadable(lazy(() => import('../pages/TankType/secondDetail')));
export const TankManageList = Loadable(lazy(() => import('../pages/TankManage/list')));
export const AutomationMigrationPage = Loadable(lazy(() => import('../pages/AutomationMigration/list')));
